// @flow
import OrgsListPageRoot from './OrgsListPageRoot';

export default OrgsListPageRoot;
